import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10.8, height: 6.8, viewBox: "0 0 10.8 6.8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.4 0L5.4 4L1.4 0L0 1.4L5.4 6.8L10.8 1.4L9.4 0Z", fill: "currentColor" }));
export default SvgChevronDown;
